export enum UserRole {
  Admin = "Admin",
  Editor = "Editor",
  Viewer = "Viewer",
}

export enum UserModalType {
  CREATE_USER = "CREATE_USER",
  CHANGE_ROLE = "CHANGE_ROLE",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  DELETE_USER = "DELETE_USER",
}

export const USER_ROLE_OPTIONS = [
  { label: UserRole.Admin, value: UserRole.Admin },
  { label: UserRole.Editor, value: UserRole.Editor },
  { label: UserRole.Viewer, value: UserRole.Viewer },
];
